import { useBreakpoint } from '@ocean/hooks'
import { Size } from '@ocean/types/dist/appearance'
import { common } from '@ocean/ui'
import { FormControlTrace, FormSkeletonWrapper } from '../Skeleton.styled'

const { Spacer, skeletonStyles } = common
const { ContentTrace, Translucent } = skeletonStyles

const FormSkeleton: React.FC = () => {
  const isDesktop = useBreakpoint('sm')

  return (
    <Translucent opacity='0.7' data-test='FormSkeleton'>
      <FormSkeletonWrapper data-test='FormSkeleton'>
        <ContentTrace data-selector='ContentTrace' size={Size.Small} width='250px' />
        <FormControlTrace width={isDesktop ? '80%' : '100%'} color='greyLight' />
        <Spacer size='large' />
        <ContentTrace data-selector='ContentTrace' size={Size.Small} width='200px' />
        <FormControlTrace width={isDesktop ? '55%' : '100%'} color='greyLight' />
        <Spacer size='large' />
        <ContentTrace data-selector='ContentTrace' size={Size.Small} width='270px' />
        <FormControlTrace width={isDesktop ? '65%' : '100%'} color='greyLight' />
      </FormSkeletonWrapper>
    </Translucent>
  )
}

export default FormSkeleton
